import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-add-edit-attorney',
  templateUrl: './add-edit-attorney.component.html',
  styleUrls: ['./add-edit-attorney.component.scss']
})
export class AddEditAttorneyComponent implements OnInit {

  @Input() object: any;
  @Input() key: any;
  @Input() extraData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
